import '@tomo/ui/styles.css';
import './styles/app.css';
import { applyTheme } from '@tomo/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { initCloud } from './data/cloud/session.ts';
import { loadIdentity } from './data/identity.ts';
import { loadRegistry } from './data/registry.ts';

async function boot() {
  applyTheme();
  await Promise.all([loadIdentity(), loadRegistry()]);
  // Cloud is optional: the app is fully usable offline / without an account.
  void initCloud();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();

// Offline app shell for production builds. In development, remove any worker left behind by a
// production preview on the same origin so it can never serve stale files.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined));
  else void navigator.serviceWorker.getRegistrations().then((list) => list.forEach((r) => void r.unregister()));
}
